document.addEventListener('DOMContentLoaded', function(){
	setSlide();
});



const setSlide =()=>{
	const bts=Array.from(document.querySelectorAll(".sevenReason ul a"));
	const ans=document.querySelectorAll(".reasonDetail");
	bts.forEach((b)=>{
		b.addEventListener("click",(e)=>{
			e.preventDefault();
			const i = bts.findIndex(list => list === b);
			targetScroll(ans[i]);
		});
	})
}


const targetScroll =(trg) =>{
	const p = trg.getBoundingClientRect().top+window.scrollY;
	const h=document.querySelector("header").clientHeight;
	window.scrollTo({
		top: p-h-30,
		behavior: 'smooth'
	});
}